import { bool, func, shape, string } from 'prop-types';
import React from 'react';
import Wrapper from '../Wrapper';
import FillInDetails from './FillInDetails';

const BookerFillInDetails = ({ bookerDetail, onClick, touched, move }) => {
  return (
    <Wrapper id="booker">
      <FillInDetails
        onClick={onClick}
        onEdit={onClick}
        content={
          bookerDetail && {
            primary: `${bookerDetail.givenName ||
              ''} ${bookerDetail.familyName || ''}`,
            secondary: bookerDetail.email,
          }
        }
        error={touched && !bookerDetail}
        move={move}
      />
    </Wrapper>
  );
};

BookerFillInDetails.propTypes = {
  onClick: func,
  touched: bool,
  bookerDetail: shape({
    givenName: string.isRequired,
    familyName: string.isRequired,
    email: string.isRequired,
  }),
  move: bool,
};

export default BookerFillInDetails;
